import {IntermediatePart} from "../../intermediatePart";

export default class Wainscoting extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'wainscoting';
    this.partName = 'Wainscoting';
    this.translateId = "visualizer.bathroom.accessories.wainscoting";
    this.canBeDisabled = true;
    this.isStoneFeature = true;
  }
}
